import $ from "jquery";
import axios from "axios";
import QRCodeStyling from "qr-code-styling";
import "bootstrap"
import 'animate.css'
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/index.css";
import banner from "url:../images/banner.png";
import footer from "url:../images/footer.png";
import qr from "url:../images/qr.png";


/**
 * Ensure the DOM is ready before mounting.
 * Because <script type="module"> loads in <head>, we check the document state.
 */
if (document.readyState === "loading") {
  	document.addEventListener("DOMContentLoaded", mount);
} else {
  	mount();
}

/**
 * Mounts the dynamic UI into the #app container.
 * This function clears any existing content and injects the
 * Information Request Form into the DOM. It also attaches form handlers.
 *
 * @function mount
 * @returns {void}
 */
function mount() {
    $("#app").empty().append(build());
    attachFormHandlers();
    attachPhoneAutoAdvance();
    loadHidden();
    generateQrCode("https://elisa-ignite.on-evp.com", "#qr-container");
}

/**
 * Returns the HTML for the form 
 */
function build() {
    return `
        <div class="container py-5">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div class="card shadow-sm border-0">
                        <div class="card-body p-5">
                        <!-- HERO BANNER -->
                        <div class="text-center mb-4">
                            <img src="${banner}" alt="Hero Banner" class="img-fluid">
                        </div>
                        <hr class="form-separator my-4" />
                        <h1 class="mb-4 text-start scn-header">Information Request</h1>

                        <form id="info-request-form" novalidate>
                            <!-- Job Title -->
                            <div class="mb-3">
                                <label for="jobTitle" class="form-label">Job Title</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    id="jobTitle"
                                    name="jobTitle"
                                    placeholder="e.g. City Planner, Economic Development Director"
                                    required
                                >
                                <div class="form-text">Your current job title</div>
                            </div>
                            <!-- Name -->
                            <div class="row mb-3">
                                <div class="col-md-6">
                                    <label for="firstName" class="form-label">Name</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="firstName"
                                    name="firstName"
                                    placeholder="First Name"
                                    required
                                >
                                <div class="form-text">First Name</div>
                            </div>
                            
                            <div class="col-md-6 d-flex align-items-end">
                                <div class="w-100">
                                    <label class="form-label invisible">Last Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="lastName"
                                        name="lastName"
                                        placeholder="Last Name"
                                        required
                                    >
                                    <div class="form-text">Last Name</div>
                                </div>
                            </div>
                        </div>

                        <!-- Email & Phone -->
                        <div class="row mb-3">
                            <div class="col-md-6">
                                <label for="email" class="form-label">E-mail</label>
                                <input
                                type="email"
                                class="form-control"
                                id="email"
                                name="email"
                                placeholder="ex: myname@example.com"
                                required
                                >
                            <div class="form-text">example@example.com</div>
                        </div>
                
                        <div class="col-md-6">
                            <label class="form-label">Phone Number</label>
                            <div class="row g-2">
                                <div class="col-3">
                                    <input 
                                        type="tel" 
                                        class="form-control" 
                                        id="countryCode" 
                                        name="countryCode" 
                                        placeholder="e.g. 1"
                                        maxlength="3"
                                        inputmode="numeric"
                                    >
                                    <div class="form-text">Country Code</div>
                                </div>
                                <div class="col-3">
                                    <input
                                        type="tel"
                                        class="form-control"
                                        id="areaCode"
                                        name="areaCode"
                                        placeholder="e.g. 415"
                                        maxlength="3"
                                        inputmode="numeric"
                                    >
                                    <div class="form-text">Area Code</div>
                                </div>
                                <div class="col-6">
                                    <input
                                        type="tel"
                                        class="form-control"
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        placeholder="e.g. 5678900"
                                        maxlength="10"
                                        inputmode="numeric"
                                    >
                                    <div class="form-text">Phone Number</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Location -->
                    <div class="mb-3 row">
                        <div class="col-4">
                            <label for="city" class="form-label">City</label>
                            <input
                                type="text"
                                class="form-control"
                                id="city"
                                name="city"
                                required
                            >
                        </div>
                        <div class="col-4">
                            <label for="state" class="form-label">State/Prov.</label>
                            <input
                                type="text"
                                class="form-control"
                                id="state"
                                name="state"
                                required
                            >
                        </div>
                        <div class="col-4">
                            <label for="country" class="form-label">Country</label>
                            <input
                                type="text"
                                class="form-control"
                                id="country"
                                name="country"
                                required
                            >
                        </div>
                    </div>

                    <!-- Program -->
                    <div class="mb-3 row d-none">
                        <div class="col-6">
                            <label for="program" class="form-label">Program</label>
                            <input
                                type="text"
                                class="form-control"
                                id="program"
                                name="program"
                            >
                        </div>
                    </div>

                    <!-- Program Interest -->
                    <div class="mb-3">
                        <label class="form-label">Program Interest</label>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="Advise on Programmatics" id="interestAdviseProgrammatics" name="programInterest">
                            <label class="form-check-label" for="interestAdviseProgrammatics">
                                Advise on Programmatics
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="Coach a Business Scholar" id="interestBusinessScholarMentor" name="programInterest">
                            <label class="form-check-label" for="interestBusinessScholarMentor">
                                Coach a Business Scholar
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="Professor Participant" id="interestProfessorParticipant" name="programInterest">
                            <label class="form-check-label" for="interestProfessorParticipant">
                                Professor Participant
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="Potential Sponsor" id="interestPotentialSponsor" name="programInterest">
                            <label class="form-check-label" for="interestPotentialSponsor">
                                Potential Sponsor
                            </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="Other (explain in the comment box)" id="interestOther" name="programInterest">
                            <label class="form-check-label" for="interestOther">
                                Other (explain in the comment box)
                            </label>
                        </div>
                    </div>

                    <!-- Comments -->
                    <div class="mb-4">
                    <label for="comments" class="form-label">Comments</label>
                    <textarea
                        class="form-control"
                        id="comments"
                        name="comments"
                        rows="5"
                    ></textarea>
                    </div>

                    <div class="d-flex justify-content-center mb-3">
                    <button type="submit" class="btn btn-success btn-lg w-50">
                        Submit
                    </button>
                    </div>
                </form>

                <!-- FOOTER BANNER (left aligned) -->
                <hr class="form-separator my-4" />
                <div class="mt-3">
                    <img src="${footer}" alt="Footer Banner" class="img-fluid" style="max-width:250px;">
                    ${process.env.ENV === "development" ? `<div id="qr-container" class="ms-4"></div>` : ""}
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  `;
}

/**
 * Handles form submission, builds a URL-encoded query string,
 * and POSTs it to process.env.API.
 *
 * @function attachFormHandlers
 * @returns {void}
 */
function attachFormHandlers() {
    $("#info-request-form").on("submit", function (e) {
        e.preventDefault();

        const API = process.env.API;
        const ENV = process.env.ENV;
        if (!API && ENV !== "development") {
            console.error("process.env.API is missing.");
            return;
        }

        const jobTitle    = $("#jobTitle").val()?.trim() || "";
        const firstName   = $("#firstName").val()?.trim() || "";
        const lastName    = $("#lastName").val()?.trim() || "";
        const city        = $("#city").val()?.trim() || "";
        const state       = $("#state").val()?.trim() || "";
        const country     = $("#country").val()?.trim() || "";
        const email       = $("#email").val()?.trim() || "";
        const areaCode    = $("#areaCode").val()?.trim() || "";
        const phoneNumber = $("#phoneNumber").val()?.trim() || "";
        const program     = $("#program").val()?.trim() || "";
        const comments    = $("#comments").val()?.trim() || "";
        const questionResponse = $("input[name='programInterest']:checked")
            .map(function () { return $(this).val(); })
            .get()
            .join(", ");

        if (!firstName || !lastName || !email || !city || !state || !country || !jobTitle) {
            showValidationError();
            return;
        }

        const fullName  = `${firstName} ${lastName}`.trim();
        const fullPhone = (areaCode || phoneNumber)
            ? `${areaCode}${phoneNumber}`.replace(/\s+/g, "")
            : "";

        const params = new URLSearchParams();

        params.append("jobTitle", jobTitle);
        params.append("name", fullName);
        params.append("email", email);
        params.append("program", program);
        params.append("comments", comments);
        params.append("city", city);
        params.append("country", country);
        params.append("state", state);
        if (questionResponse) {
            params.append("QuestionResponse", questionResponse);
        }

        if (fullPhone !== "") {
            params.append("phoneNumber", fullPhone);
        }
        
        const finalUrl = `${API || "(no API in development)"}?${params.toString()}`;

        console.log("POST URL:", finalUrl);

        if (ENV === "development") {
            console.log("Skipping axios.post in development environment.");
            showSuccessMessage();
        } else {
            axios.post(finalUrl)
                .then(() => { // this will never trigger due to CORS
                    showSuccessMessage();
                })
                .catch(err => {
                    if (!err.response) {
                        showSuccessMessage();
                    } else {
                        showFailureMessage();
                    }
                });
        }
    });
}

/**
 * Automatically advances phone-related inputs when they reach maxlength.
 */
function attachPhoneAutoAdvance() {
    const $countryCode = $("#countryCode");
    const $areaCode = $("#areaCode");
    const $phoneNumber = $("#phoneNumber");
    const $city = $("#city");

    // When re-focusing a filled phone field, select all so new typing replaces it.
    [$countryCode, $areaCode, $phoneNumber].forEach($field => {
        $field.on("focus", function () {
            if (this.value && this.select) {
                this.select();
            }
        });
    });

    $countryCode.on("input", function () {
        const max = this.maxLength;
        if (max > 0 && this.value.length >= max) {
            $areaCode.trigger("focus");
        }
    });

    $areaCode.on("input", function () {
        const max = this.maxLength;
        if (max > 0 && this.value.length >= max) {
            $phoneNumber.trigger("focus");
        }
    });

    $phoneNumber.on("input", function () {
        const max = this.maxLength;
        if (max > 0 && this.value.length >= max) {
            $city.trigger("focus");
        }
    });
}

/**
 * Dynamically loads hidden field values from environment variables
 * (injected by Parcel at build time via .env).
 *
 * Populates:
 * - Program field (`#program`)
 *
 * Behavior:
 * - Always sets program value.
 * - Reveals hidden fields only when ENV === "development".
 *
 * @function loadHidden
 * @returns {void}
 *
 * @example
 * loadHidden();
 * // Program row becomes visible in development builds.
 */
function loadHidden() {
  const ENV = process.env.ENV;
  const PROGRAM = process.env.PROGRAM;

  const $programField = $("#program");
  const $programRow = $programField.closest(".row");

  // Always populate the hidden program field
  if ($programField.length) {
      $programField.val(PROGRAM);
  }

  // Reveal hidden fields in development mode
  if (ENV === "development") {
      $programRow.removeClass("d-none");
  }
}

/**
 * Generates a branded QR code with custom colors and an optional logo.
 *
 * @param {string} text - The text or URL to encode.
 * @param {string} targetSelector - CSS selector where QR should be rendered.
 * @returns {void}
 */
function generateQrCode(text, targetSelector) {
    const container = document.querySelector(targetSelector);
    if (!container) return;

    container.innerHTML = "";

    const qrCode = new QRCodeStyling({
        width: 240,
        height: 240,
        data: text,
        type: "canvas",
        margin: 10,
        dotsOptions: {
        color: "#2D7F78", // your SCIL teal
        type: "rounded"
        },
        backgroundOptions: {
        color: "#FFFFFF"
        },
        image: qr,
        imageOptions: {
        crossOrigin: "anonymous",
        margin: 4,
        imageSize: 0.25 // 25% of QR area
        }
    });

    qrCode.append(container);
}

/**
 * Displays a validation error alert above the form when required fields
 * (First Name, Last Name, Email) are missing.
 *
 * Adds Bootstrap "is-invalid" styling to any empty required fields.
 * The alert includes a dismiss button and animates into view.
 *
 * This function does NOT submit the form and is called *before* any axios request.
 *
 * @function showValidationError
 * @returns {void}
 *
 * @example
 * if (!firstName || !lastName || !email) {
 *   showValidationError();
 *   return;
 * }
 */
function showValidationError() {
  $("#app").prepend(`
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      <strong>Please complete all required fields:</strong><br>
      First Name, Last Name, and Email are required.
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    </div>
  `);

  $("#firstName, #lastName, #email").each(function () {
    if (!$(this).val()?.trim()) {
      $(this).addClass("is-invalid");
    } else {
      $(this).removeClass("is-invalid");
    }
  });
}

/**
 * Displays a success message after the form submission completes.
 * This function replaces the form content inside the #app container
 * with a confirmation message. The success message is shown for both:
 *  - True HTTP 200 responses (rare due to CORS)
 *  - CORS-blocked-but-successful POSTs (Podio received the data)
 *
 * @function showSuccessMessage
 * @returns {void}
 *
 * @example
 * showSuccessMessage();
 * // → Replaces the form with a "Thank you" acknowledgement.
 */
function showSuccessMessage() {
  $("#app").html(`
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-5">
                        <div class="text-center mb-4">
                            <img src="${banner}" alt="Hero Banner" class="img-fluid">
                        </div>
                        <hr class="form-separator my-4" />
                        <div class="text-center p-5">
                            <h2 class="scil-header">Thank you for your request!</h2>
                            <p>We’ve received your submission and will get back to you shortly.</p>
                        </div>
                        <hr class="form-separator my-4" />
                        <div class="mt-3">
                            <img src="${footer}" alt="Footer Banner" class="img-fluid" style="max-width:250px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  `);
}

/**
 * Displays an error message when submission fails due to a true HTTP/network error.
 * Note: CORS-blocked requests still count as success for this particular endpoint
 * because the Podio webhook receives the POST even though the browser blocks access
 * to the response.
 *
 * This message is only shown when:
 *  - axios receives an actual HTTP error (response present in err.response)
 *  - OR when the API endpoint is missing/misconfigured
 *
 * @function showFailureMessage
 * @returns {void}
 *
 * @example
 * showFailureMessage();
 * // → Displays an "Uh oh!" message indicating the request failed.
 */
function showFailureMessage() {
  $("#app").html(`
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-5">
                        <div class="text-center mb-4">
                            <img src="${banner}" alt="Hero Banner" class="img-fluid">
                        </div>
                        <hr class="form-separator my-4" />
                        <div class="text-center p-5">
                            <h2 class="text-danger">Uh oh!</h2>
                            <p>Something went wrong submitting your request. Please try again.</p>
                        </div>
                        <hr class="form-separator my-4" />
                        <div class="mt-3">
                            <img src="${footer}" alt="Footer Banner" class="img-fluid" style="max-width:250px;">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  `);
}
